module.exports = __webpack_public_path__ + "img/gas.b6def63d.svg";